module.exports = __webpack_public_path__ + "img/men1.fe10304d.png";